export const ITEM_WIDTH = 150
export const ITEM_HEIGHT = 150
export const WIDE_ASPECT_RATIO = 1.5
